import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function rescheduleAppointment(arg: {
  appointments: {
    appointment_id: string | number;
    new_appointment_start: string;
    new_appointment_end: string;
    admin_note?: string;
    place_of_service_code_override?: string;
  }[];
  force_book_over_blocked: boolean;
  onBehalfOf?: string;
}): Promise<AppointmentMetaData> {
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/timeslot_orchid_pro/reschedule${
      arg.onBehalfOf ? `?on_behalf_of=${arg.onBehalfOf}` : ""
    }`,
    {
      method: "POST",
      body: JSON.stringify({
        appointments: arg.appointments,
        force_book_over_blocked: arg.force_book_over_blocked ?? true,
      }),
    },
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }
  const json = await response.json();
  const [appointment] = json.appointments;
  return appointment;
}
